import { fetchApi } from '@/services/api-client';

import type { InquiryNote } from '../inquiry-notes/inquiry-notes';

export const CONTACT_INQUIRIES_PATH = '/contact-inquiries';

export type ContactInquiryStatus = 'new' | 'in_progress' | 'resolved';

export type ContactInquiry = {
  id: string;
  name: string;
  email: string;
  subject: string;
  message: string;
  status: ContactInquiryStatus;
  createdAt: string;
  updatedAt: string;
};

export type ContactInquiryDetail = ContactInquiry & {
  notes: InquiryNote[];
};

export const contactInquiriesApi = {
  getAll: (status?: ContactInquiryStatus) => {
    const params = status ? `?status=${status}` : '';
    return fetchApi<ContactInquiry[]>(`${CONTACT_INQUIRIES_PATH}${params}`);
  },
  getById: (id: string) => fetchApi<ContactInquiryDetail>(`${CONTACT_INQUIRIES_PATH}/${id}`),
  updateStatus: (id: string, status: ContactInquiryStatus) =>
    fetchApi<ContactInquiry>(`${CONTACT_INQUIRIES_PATH}/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status }),
    }),
  delete: (id: string) => fetchApi<{ success: boolean }>(`${CONTACT_INQUIRIES_PATH}/${id}`, { method: 'DELETE' }),
};
